import Vue from 'vue';
import VueI18n from 'vue-i18n';

import us from '@/langs/en-US.json';
import tw from '@/langs/zh-TW.json';
import cn from '@/langs/zh-CN.json';
import jp from '@/langs/ja-JP.json';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || (navigator.language ?? 'en-US'),
  fallbackLocale: 'en-US',
  messages: {
    'en-US': us,
    'zh-TW': tw,
    'zh-CN': cn,
    'ja-JP': jp,
  },
});

export default i18n;
